import React from 'react';

import SubstitutePlayer, { ISubstitutePlayer } from '../../atoms/substitute-player/substitute-player';
import SubstituteTrainer, { ISubstituteTrainer } from '../../atoms/substitute-trainer/substitute-trainer';
import PlayerCardWrapper from '../player-card-wrapper/player-card-wrapper';
import { makeClassNames } from '../../../utils/styles';
import './substitute-players-card.scss';
import Text from '../../atoms/text/text';

const classNames = () =>
  makeClassNames({
    content: 'substitute-players-card__content',
    header: 'substitute-players-content__header',
    itemsWrapper: 'substitute-players-content__items-wrapper',
    itemsSpacer: 'substitute-players-content__items-spacer',
    headerTitle: 'substitute-players-header__title',
  });

const cn = classNames();

export interface ISubsitutePlayersCard {
  type: string;
  title?: string;
  players: ISubstitutePlayer[];
  playerTeamColor: string;
  trainer: ISubstituteTrainer;
}

const SubsitutePlayersCard = (props: ISubsitutePlayersCard) => {
  const { type, title, players, playerTeamColor, trainer } = props;

  return (
    <PlayerCardWrapper playerTeamColor={playerTeamColor} hasHeadShot={false}>
      <div className={cn.content}>
        {title ? (
          <div className={cn.header}>
            <Text color="blue" fontSize="22" fontWeight="500" className={cn.headerTitle}>
              {title}
            </Text>
          </div>
        ) : null}
        {players.map((player, index) => (
          <div key={`player-${index}`} className={cn.itemsWrapper}>
            <SubstitutePlayer
              type={type}
              name={player.name}
              playerUrl={player.playerUrl}
              enterTime={player.enterTime}
              points={player.points}
              mvp={player.mvp}
            />
            <div className={cn.itemsSpacer} />
          </div>
        ))}
      </div>
      <div className={cn.content}>
        <SubstituteTrainer name={trainer.name} prefix={trainer.prefix} points={trainer.points} />
      </div>
    </PlayerCardWrapper>
  );
};

export default SubsitutePlayersCard;
